import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// eslint-disable-next-line no-restricted-imports
import { useLocationPathname } from '@rocketlane/rocket-router';
import { Image } from 'antd';
import { isMobileOnly } from 'react-device-detect';
// eslint-disable-next-line no-restricted-imports
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { RoutePaths } from 'constant';
import { useAccountMetaQuery } from 'queries';
const StyledPage = styled(Page)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: var(--zindex-popover);
  align-items: center;
  padding: var(--spacing-07);
`;
const CenterAlignedDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;
const Message = styled.h2`
  text-align: center;
  padding: var(--spacing-05);
`;
export const MobileViewOverlay = ({ children })=>{
    var _data_company;
    const { data } = useAccountMetaQuery();
    const excludedSimpleRoutes = [
        RoutePaths.linkAction,
        RoutePaths.addApiKey,
        RoutePaths.respSpacesTab
    ];
    const pathname = useLocationPathname();
    // const navigation = useNavigation();
    const byPassMobileScreenCheck = ()=>{
        const splitPathname = pathname.split('/');
        if (excludedSimpleRoutes.includes(pathname)) {
            return true;
        }
        if (pathname.includes('responsive') || pathname.includes('api-key') || pathname.startsWith('/forms') && splitPathname[2] !== undefined && splitPathname[3] !== undefined) {
            return true;
        }
        if (navigator.userAgent.includes('Mobile') && pathname.includes('login')) {
            return true;
        }
        return true;
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: !byPassMobileScreenCheck() && isMobileOnly ? /*#__PURE__*/ _jsxs(StyledPage, {
            children: [
                data && ((_data_company = data.company) === null || _data_company === void 0 ? void 0 : _data_company.companyLogoUrl) ? /*#__PURE__*/ _jsx(Image, {
                    width: 80,
                    height: 80,
                    preview: false,
                    src: data.company.companyLogoUrl,
                    title: "logo",
                    alt: "logo"
                }) : null,
                /*#__PURE__*/ _jsx(CenterAlignedDiv, {
                    children: /*#__PURE__*/ _jsx(Message, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "mobile_view.message"
                        })
                    })
                })
            ]
        }) : children
    });
};
